/* ========================================================================
 *  module create job
 * ========================================================================
*/
FD.TIMETRACKER = (function ($, me) {
    'use strict';

    var child = me.TIMETRACKER || {};


    /* ========================================================================
     *  vars
     * ========================================================================
    */
    var URL_TIMETRACKER = '/TimeTracker/Modules/';

    var PARENT_ELEM = '[data-parent="true"]';
    var FORM_ELEM = '[data-fd="form"]';
    var MODAL_ELEM = '#TIME_TRACKER_MODAL';
    var MODAL_PDT_ELEM = '#TIME_PDT_MODAL';
    var JOB_PO_ROWDATA = '#JOB_PO_ROWDATA';

    var PASS_THRU = '#PASS_THRU';
    var CAP_X = '#CAP_X';
    var SIMILAR_JOBS = '#SIMILAR_JOBS';
    var SUBSCRIPTIONS_LIST = '#SUBSCRIPTIONS_LIST';
    var SUBSCRIPTIONS_LIST_UL = '#SUBSCRIPTIONS_LIST_UL';
    var modal;
    var notify;
    var label;
    var editing = false;
    var projectID = null;
    var currentJobId ;
    var jobOptions = {};
    var defaults = {
        addCallback: null, 
        hideCallback: null,
        initialTitle: null
    };
    var subscribedUserList = [];

    /* ========================================================================
     *  tags
     * ========================================================================
    */

    var tag = {
        CREATE_BTN: 10,
        JOB_TYPE: 11,
        JOB_NAME: 12,
        SAVE_BTN: 13,
        ADD_PDT_BTN: 14,
        SAVE_PDT_BTN: 15,

        EDIT_PROJECT: 20,
        ADD_SUBSCRIPTION: 23,
        CELL_CHANGE: 25,
        ADD_PO_NUMBER: 26,
        ADD_CUSTOM_PO: 27,
        REMOVE_PO: 28,
        Delete_SUBSCRIPTION:700
    };


    /*
    * ========================================================================
    * Objects
    * ========================================================================
    */

    var jobType = {
        NONE: 0,
        CAP_X: 4,
        PASS_THRU: 7
    };



    /* ========================================================================
     *  CRUD Functions
     * ========================================================================
    */

    function setSaveButton(data, createJob) {
        if (me.CONTROL.Validate(MODAL_ELEM)) {
            if (createJob) {
                handleJobAddCRUD();
            } else {
                handleJobFieldCRUD(data);
            }
        }
    }

    function validateModal() {
        const hasJobs = $("tr:not(.footer):not([data-noresults])", JOB_PO_ROWDATA).length > 0;
        if (!hasJobs) {
            notify.alert(label["PORequiredForJobPDTProjectNumber"]);
        }
        return me.CONTROL.Validate(MODAL_ELEM) && hasJobs;
    }


    function handleJobAddCRUD() {
        var createJobModalItem = me.getFormFields(MODAL_ELEM);
        createJobModalItem.isActive = true;
        createJobModalItem.JobPoList = getPoList();
        if (+createJobModalItem.JobTypeID !== jobType.CAP_X && +createJobModalItem.JobTypeID !== jobType.PASS_THRU) {
            createJobModalItem.FOXItemID = -1;
        }
        var options = {
            params: {
                item: createJobModalItem
            },
            url: URL_TIMETRACKER + 'HandleJobAddCRUD',
            callback: afterData,
            isloader: true,
            delay: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {            
            if (result.data && result.data.NewJobID > 0) {
                if (jobOptions.addCallback && typeof jobOptions.addCallback === 'function') {
                    jobOptions.addCallback(result.data);
                }
                $(MODAL_ELEM).modal('hide');
            } else if (result.data.IsValid == false && result.data.Message !== '') {
                notify.alert(result.data.Message);
            } else if (result.data.IsValid === false) {
                notify.alert(label['DuplicateJobNameTypeCombination']);
            }
        }
    }

    function handleJobFieldCRUD(data) {
        if (!editing) {
            return;
        }
        var formFields = me.getFormFields(MODAL_ELEM);
        var editJobModalItem = formFields;
        editJobModalItem.JobID = data.parentid;
        editJobModalItem.JobPoList = getPoList();
        if (+editJobModalItem.JobTypeID !== jobType.CAP_X && +editJobModalItem.JobTypeID !== jobType.PASS_THRU) {
            editJobModalItem.FOXItemID = -1;
        }
        editJobModalItem.subscribersIDList = [];
        for (var x = 0; x < subscribedUserList.length; x++) {
            editJobModalItem.subscribersIDList.push(subscribedUserList[x].ID);
        }

        var options = {
            params: editJobModalItem,
            url: URL_TIMETRACKER + 'HandleJobFieldCRUD',
            callback: afterData,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result.data.IsValid == false && result.data.Message !== '') {
                notify.alert(result.data.Message);
            }
            else if (result.data.IsValid === false) {
                notify.alert(label['DuplicateJobNameTypeCombination']);
            } else {
                $(MODAL_ELEM).modal('hide');
            }
        }
    }


    /*
    * ========================================================================
    * Partial Views
    * ========================================================================
    */

    //  load modal
    function getCreateJobModal() {
        if (me.getModalLock()) {
            return;
        }


        editing = false;

        me.setModalLock(true);
        var options = {
            params: {
                initialTitle: jobOptions.initialTitle
            },
            url: URL_TIMETRACKER + 'GetCreateJobModal',
            callback: afterData,
            ishtml: true,
            cancelprevious: true,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {

            $('body').append(result.data);

            modal = $(MODAL_ELEM);

            modal.off().on('shown.bs.modal', function () {
                me.CONTROL.setValidateContainer(null); // MUST BE FIRST
                modal.enableControls();
                if (notify !== null) {
                    notify = new Notify();
                }
                label = me.getLabel();

                if (jobOptions.initialTitle && jobOptions.initialTitle.length > 0) {
                    checkSimilarJobs({ data: null });
                }

                me.setModalLock(false);
            }).on('hidden.bs.modal', function () {
                me.setToolTip();
                $(MODAL_ELEM).remove();
                $(MODAL_PDT_ELEM).remove();
                if (jobOptions.hideCallback && typeof jobOptions.hideCallback === 'function') {
                    jobOptions.hideCallback();
                }
            }).modal('show');
        }
    }


    function getEditJobModal(ID, callback) {
        if (me.getModalLock()) {
            return;
        }
        me.setModalLock(true);
        projectID = null;
        editing = true;
        jobOptions = {
            hideCallback: callback,
            ID: ID
        };

        modal = $(MODAL_ELEM);
        var options = {
            url: URL_TIMETRACKER + 'GetEditJobModal',
            params: {
                jobID: ID
            },
            callback: afterData,
            ishtml: true,
            cancelprevious: true,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            $('body').append(result.data);

            modal = $(MODAL_ELEM);
            setSubscribedUserList();

            modal.off().on('shown.bs.modal', function () {
                me.CONTROL.setValidateContainer(null);
                modal.enableControls();
                notify = notify || new Notify();
                label = me.getLabel();
                me.setModalLock(false);
            }).on('hidden.bs.modal', function () {
                handleEditJobModalCleanup();
            }).modal('show');
        }
    }


    function handleJobTypeChange(data) {
        var modal = $(MODAL_ELEM);
        switch (+data.value) {
            case jobType.PASS_THRU:
                modal.find(PASS_THRU).removeClass('hidden');
                modal.find(CAP_X).addClass('hidden');
                break;
            case jobType.CAP_X:
                modal.find(PASS_THRU).addClass('hidden');
                modal.find(CAP_X).removeClass('hidden');
                break;
                break;
            default:
                modal.find(PASS_THRU).addClass('hidden');
                modal.find(CAP_X).addClass('hidden');
        }
        handleCapXPassThruItem(+data.value);
    }


    function checkSimilarJobs(data) {
        var modal = $(MODAL_ELEM);
        var jobModalItem = me.getFormFields(MODAL_ELEM);
        var item = {
            jobName: jobModalItem.JobName,
            jobType: +jobModalItem.JobTypeID,
            JobId: data.parentid ? +data.parentid : -1 // The job id of edited job if parent id exist
        };
        if (item.jobName === "") {
            $(SIMILAR_JOBS).closest('li').addClass('hidden').next().addClass('hidden');
            return;
        }
        var options = {
            url: URL_TIMETRACKER + "CheckSimilarJobs",
            params: item,
            callback: afterData,
            ishtml: true,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result.data) {
                modal.find(SIMILAR_JOBS).closest('li').removeClass('hidden').next().removeClass('hidden');
                modal.find(SIMILAR_JOBS).html(result.data);
            } else {
                modal.find(SIMILAR_JOBS).closest('li').addClass('hidden').next().addClass('hidden');
            }
        }
    }


    function getEditProjectModal(data) {
        projectID = +data.parentid;
        data.e.tooltip('hide');
        $(MODAL_ELEM).off('hidden.bs.modal').on('hidden.bs.modal', function () {
            me.PROJECTEDIT.loadEditProjectModal(projectID, showJobModule);
        }).modal('hide');
    }


    function showJobModule() {
        var projectTitle = $(MODAL_ELEM + ' .projecttitle');
        projectTitle.append('<i class="fa fa-fw fa-spin fa-spinner"></i>');

        var options = {
            url: URL_TIMETRACKER + "GetProjectTitle",
            params: {
                projectID: projectID,
                jobID: jobOptions.ID
            },
            callback: afterData,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result.data) {
                projectTitle.text(result.data).find('i').remove();
            } else { // User deleted the project or un-linked the job
                projectTitle.closest('[data-parent]').data('parentid', null).html(label["NoLinkedProject"]);
            }
            projectID = null;
        }
        $(MODAL_ELEM).off('hidden.bs.modal').on('hidden.bs.modal', function () {
            handleEditJobModalCleanup();
        }).modal('show');
    }


    function handleCapXPassThruItem(jobTypeID) {
        var modal = $(MODAL_ELEM);

        var capXPassThruItemSelect = modal.find('[data-fldname="FOXItemID"]');

        if (jobTypeID === jobType.PASS_THRU || jobTypeID === jobType.CAP_X) {
            modal
                .find('.capx_passthruitem').removeClass('hidden').end()
                .find('[data-fldname="FOXItemID"]').prop('required', true).attr('data-validate', true);
            if (modal.find('[data-fldname="CellID"]').data('value') > 0) {
                capXPassThruItemSelect.find('option:first-child').text(label['Select']);
            } else {
                capXPassThruItemSelect.find('option:gt(0)').remove();
                capXPassThruItemSelect.find('option:first-child').text(label['SelectCell'])
                return;
            }
            var options = {
                url: URL_TIMETRACKER + "GetItemListByJobTaskTypeCell",
                params: {
                    jobType: jobTypeID,
                    cellID: +modal.find('[data-fldname="CellID"]').data('value')
                },
                callback: afterData,
                isloader: true
            };

            me.AJAX.setAJAX(options);
        } else {
            modal
                .find('.capx_passthruitem').addClass('hidden').end()
                .find('[data-fldname="FOXItemID"]').prop('required', false).attr('data-validate', false);
            capXPassThruItemSelect.find('option:gt(0)').remove();
        }

        function afterData(result) {
            if (result.data) {
                capXPassThruItemSelect.find('option:gt(0)').remove().data('value', -1).val(-1);
                for (var x = 0; x < result.data.length; x++) {
                    capXPassThruItemSelect.append(new Option(result.data[x].Name, result.data[x].ID));
                }
            }
        }
    }


    function getJobSubscribedUsers() {
        var options = {
            url: URL_TIMETRACKER + 'ReturnJobSubscribedUsersToSubscribedUsersList',
            params: {
             subscribedUsers: subscribedUserList
            },
            callback: afterData,
            isloader: true,
            ishtml: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            $(SUBSCRIPTIONS_LIST).html(result.data).enableControls();
        }
    }
    

    function getAddPDTProjectNumberModal() {
        if (!validateModal()) {
            return;
        }

        $('[data-fldname=PDTProjectNumber]', MODAL_PDT_ELEM).val('');
        $(MODAL_PDT_ELEM).enableControls().modal('show')
            .off('bs.modal')
            .on('hidden.bs.modal', function () {
                $('body').addClass('modal-open');
            });
    }

    function updateJobPoList(data) {
        var params = {
            model: {
                JobPoList: getPoList()
            }
        };

        switch (data.tag) {
            case tag.ADD_PO_NUMBER:
                params.poId = data.value;
                params.customPoNumber = data.raw.label.split(':')[0];
                break;
            case tag.ADD_CUSTOM_PO:
                params.customPoNumber = data.e.prev().val();
                if (params.customPoNumber == '') {
                    return;
                }
                break;
        }

        var options = {
            url: URL_TIMETRACKER + 'UpdateJobPoList',
            params: params,
            callback: afterData,
            isloader: true,
            ishtml: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            $(JOB_PO_ROWDATA).html(result.data).enableControls();

            switch (data.tag) {
                case tag.ADD_PO_NUMBER:
                    data.e.val('');
                    break;
                case tag.ADD_CUSTOM_PO:
                    data.e.prev().val('');
                    break;
            }
        }
    }


    function removeJobPoItem(data) {
        data.e.closest('tr').remove();

        updateJobPoList(data);
    }

    /* ========================================================================
     *  Helper Methods
     * ========================================================================
    */


    function handleEditJobModalCleanup() {
        me.setToolTip();
        $(MODAL_ELEM).remove();
        $(MODAL_PDT_ELEM).remove();
        editing = false;
        if (jobOptions.hideCallback && typeof jobOptions.hideCallback === 'function') {
            jobOptions.hideCallback();
        }
    }

    function addSubscribedUser(data) {
        for (var x = 0; x < subscribedUserList.length; x++) {
            if (subscribedUserList[x].ID === +data.value) {
                notify.info(label["ThisUserIsAlreadySelected"]);
                return;
            }
        }

        subscribedUserList.push({
            ID: +data.value,
            StandardName: data.label
        });
        data.e.val('').data({ value: null, initial: null }).attr({ 'data-value': null, 'data-initial': null });
        getJobSubscribedUsers();
        
    }


    function removeSubscribedUser(data) {
        for (var x = 0; x < subscribedUserList.length; x++) {
            if (subscribedUserList[x].ID === +data.parentid) {
                subscribedUserList.splice(x, 1);
                break;
            }
        }

        data.e.closest('[data-parent]').remove();
    }


    function setSubscribedUserList() {
        subscribedUserList=[];
        $(SUBSCRIPTIONS_LIST_UL).find('[data-parent]').each(function() { 
            subscribedUserList.push({
                ID: $(this).data('parentid'),
                StandardName: $(this).data('user')
                });
           });
    }

    function getPoList() {
        return $("tr:not(.footer):not([data-noresults])", JOB_PO_ROWDATA).map((idx, self) => me.getFormFields(self)).toArray();
    }

    function updatePDTProjectNumber(data) {
        $('.modal-backdrop').remove();
        $('[data-fldname=PDTProjectNumber]', MODAL_ELEM).val($('[data-fldname=PDTProjectNumber]', MODAL_PDT_ELEM).data('value'));
        $('[data-tag=' + tag.SAVE_BTN + '],[data-tag=' + tag.CREATE_BTN + ']', MODAL_ELEM).click();
    }

    /* ========================================================================
     *  page init
     * ========================================================================
    */


    child.init = function () { };

    // Display add job modal
    // options: add job modal options
    // addCallback: This is used to fire a callback from the function passed in
    child.getCreateJobModal = function (options) {
        jobOptions = $.extend({}, defaults, options);
        getCreateJobModal();
    };
    child.getEditJobModal = getEditJobModal;
    //   after control event
    child.getAfterControlEvent = function (data) {
        var result = data;

        switch (result.tag) {
            case tag.CREATE_BTN:
                setSaveButton(result, true);
                break;
            case tag.SAVE_BTN:
                setSaveButton(result, false);
                break;
            case tag.ADD_PDT_BTN:
                getAddPDTProjectNumberModal(result);
                break;
            case tag.SAVE_PDT_BTN:
                updatePDTProjectNumber(result);
                break;
            case tag.JOB_TYPE:
                handleJobTypeChange(result);
                checkSimilarJobs(result);
                break;
            case tag.JOB_NAME:
                checkSimilarJobs(result);
                break;
            case tag.CELL_CHANGE:
                handleCapXPassThruItem(+$(MODAL_ELEM + ' [data-fldname=JobTypeID]').val());
                break;
            case tag.EDIT_PROJECT:
                getEditProjectModal(result);
                break;
            case tag.ADD_SUBSCRIPTION:
                addSubscribedUser(result);
                break;
            case tag.Delete_SUBSCRIPTION:
                removeSubscribedUser(result);
                break;
            case tag.ADD_PO_NUMBER:
            case tag.ADD_CUSTOM_PO:
                updateJobPoList(result);
                break;
            case tag.REMOVE_PO:
                removeJobPoItem(result);
                break;

        }
    };

    return child;
}(jQuery, FD));